import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

interface DetailPanelProps {
  type: 'faq' | 'symptom';
  rowNumber: number;
  data: Record<string, unknown>;
  onClose: () => void;
}

export const DetailPanel: React.FC<DetailPanelProps> = ({ type, rowNumber, data, onClose }) => {
  return (
    <div className="mt-4 overflow-hidden rounded-lg border border-gray-200">
      <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-3">
        <span className="text-sm font-semibold">行{rowNumber} の詳細プレビュー</span>
        <button onClick={onClose} className="text-sm text-gray-400 hover:text-gray-600">
          閉じる
        </button>
      </div>
      <div className="p-4">
        {type === 'faq' ? (
          <div className="grid grid-cols-[100px_1fr] gap-2 text-sm">
            <span className="font-medium text-gray-500">カテゴリ:</span>
            <span>
              {String(data.categoryName)} &gt; {String(data.faqCategoryName)}
            </span>
            <span className="font-medium text-gray-500">質問:</span>
            <span>{String(data.question)}</span>
            <span className="font-medium text-gray-500">回答:</span>
            <div className="prose prose-sm max-w-none rounded-md border border-gray-100 bg-gray-50 p-3">
              <ReactMarkdown remarkPlugins={[remarkBreaks]}>{String(data.answer)}</ReactMarkdown>
            </div>
            <span className="font-medium text-gray-500">初期表示:</span>
            <span>{data.isInitial ? '○' : ''}</span>
          </div>
        ) : (
          <div className="grid grid-cols-[100px_1fr] gap-2 text-sm">
            <span className="font-medium text-gray-500">カテゴリ:</span>
            <span>{String(data.categoryName)}</span>
            <span className="font-medium text-gray-500">症状名:</span>
            <span>{String(data.symptomName)}</span>
            <span className="font-medium text-gray-500">原因:</span>
            <div className="prose prose-sm max-w-none rounded-md border border-gray-100 bg-gray-50 p-3">
              <ReactMarkdown remarkPlugins={[remarkBreaks]}>{String(data.cause)}</ReactMarkdown>
            </div>
            <span className="font-medium text-gray-500">対処法:</span>
            <div className="prose prose-sm max-w-none rounded-md border border-gray-100 bg-gray-50 p-3">
              <ReactMarkdown remarkPlugins={[remarkBreaks]}>{String(data.solution)}</ReactMarkdown>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
